import React from 'react';
import { Box, IconButton, InputBase } from '@mui/material';
import { chatStyles } from '../styles';
import AudioGravador from '../AudioGravador';
import { ArrowUpward } from '@mui/icons-material';

interface ChatInputProps {
  input: string;
  setInput: (input: string) => void;
  onSendMessage: () => void;
  onAudioTranscription: (text: string) => void;
  loading: boolean;
  conversationId?: string | null | undefined;
  setLoading: (loading: boolean) => void;
  scrollToBottom?: (force?: boolean) => void;
  onResolveConversationId?: () => Promise<string | undefined>;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  input,
  setInput,
  onSendMessage,
  onAudioTranscription,
  loading,
  setLoading,
  conversationId,
  scrollToBottom,
  onResolveConversationId,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  return (
    <Box
      sx={chatStyles.inputContainer}
      data-disabled={loading ? 'true' : 'false'}
    >
      <InputBase
        fullWidth
        multiline
        minRows={1}
        maxRows={4}
        placeholder="Escreva aqui como posso te ajudar..."
        value={input}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        sx={chatStyles.input}
        disabled={loading}
        data-testid="lia-chat-input"
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AudioGravador
          onTranscricao={onAudioTranscription}
          loading={loading}
          setLoading={setLoading}
          conversationId={conversationId}
          scrollToBottom={scrollToBottom}
          onResolveConversationId={onResolveConversationId}
        />
        <IconButton
          onClick={onSendMessage}
          sx={chatStyles.sendButton}
          disabled={loading}
          aria-label="Enviar mensagem"
          data-testid="lia-chat-send-button"
        >
          <ArrowUpward sx={chatStyles.sendIcon} />
        </IconButton>
      </Box>
    </Box>
  );
};
